<template>
    <button
        class="btn px-8 font-bold uppercase text-sm"
        :class="{ 'btn-primary': status === 'accept', 'btn-line rounded-full': status === 'cancel' }"
        @click="attemptStatusChange"
    >
        {{ label }}
    </button>
</template>

<script>
import { delay } from '../../utils';

export default {
    props: {
        label: {
            type: String,
            required: true
        },
        bidId: {
            type: [String, Number],
            required: true
        },
        status: {
            type: String,
            required: true,
            validator: function(value) {
                return ['accept', 'cancel'].indexOf(value) !== -1;
            }
        }
    },

    methods: {
        async attemptStatusChange() {
            if (confirm('Are you sure you want to proceed?')) {
                await axios.put(`/api/bids/${this.bidId}/${this.status}`);

                NProgress.inc();
                await delay(1000);
                NProgress.done();
                window.location.reload();
            }
            /*
            this.$confirm(this.getMessage(), this.handleStatusChange, {
                confirm: {
                    yes: this.status === 'accept' ? 'Yes, Accept Application' : 'Yes, Cancel My Application'
                },
                onSuccess: this.onSuccess
            });
            */
        },

        async handleStatusChange() {
            await axios.put(`/api/bids/${this.bidId}/${this.status}`);
        },

        async onSuccess() {
            NProgress.inc();
            await delay(1000);
            NProgress.done();
            window.location.reload();
        },

        getMessage() {
            if (this.status === 'accept') {
                return `Once you accept this application, your job will be in processing and the chosen freelancer
                will start working. In case of you have to involve in a debate, you cannot send the dispute for this job.`;
            } else {
                return `Once you cancel the application, this job will be removed from your working list. However, you can apply to this job again after canceling.`;
            }
        }
    }
};
</script>
